module.exports = __webpack_public_path__ + "img/7.8498dc76.svg";